module.exports = __webpack_public_path__ + "static/media/places.5b87b83b.png";